import { render, staticRenderFns } from "./sageChart.vue?vue&type=template&id=2dfb41a0&scoped=true"
import script from "./sageChart.vue?vue&type=script&lang=js"
export * from "./sageChart.vue?vue&type=script&lang=js"
import style0 from "./sageChart.vue?vue&type=style&index=0&id=2dfb41a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb41a0",
  null
  
)

export default component.exports